var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
const ERROR_IMG_SRC = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==';
export function ImageWithFallback(props) {
    const [didError, setDidError] = useState(false);
    const handleError = () => {
        setDidError(true);
    };
    const { src, alt, style, className } = props, rest = __rest(props, ["src", "alt", "style", "className"]);
    return didError ? (_jsx("div", { className: `inline-block bg-gray-100 text-center align-middle ${className !== null && className !== void 0 ? className : ''}`, style: style, children: _jsx("div", { className: "flex items-center justify-center w-full h-full", children: _jsx("img", Object.assign({ src: ERROR_IMG_SRC, alt: "Error loading image" }, rest, { "data-original-url": src })) }) })) : (_jsx("img", Object.assign({ src: src, alt: alt, className: className, style: style }, rest, { onError: handleError })));
}
